import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';

export type Breakpoint = keyof typeof theme.mediaMaxWidth;
export type MediaMatchProps = {
  greaterThan?: Breakpoint;
  lessThan?: Breakpoint;
} & HTMLAttributes<HTMLDivElement>;
export const MediaMatch = ({lessThan, greaterThan, ...rest}: MediaMatchProps) => (
  <div
    className={css([
      {display: 'none'},
      lessThan && {[theme.mediaMaxWidth[lessThan]]: {display: 'block'}},
      greaterThan && {[mediaMinWidth[greaterThan]]: {display: 'block'}},
    ])}
    {...rest}
  />
);
const mediaMinWidth = Object.fromEntries(
  Object.entries(theme.mediaMaxWidth).map(([breakpoint, size]) => [
    breakpoint,
    size.replace('max', 'min'),
  ]),
);
